<template>
  <div class="question-comment">
    <comment-item
      :item="comment"
      type="remark"
      @reply="reply"
      @like="likeFn"
      @click.stop="showAllCommentModal"
    />
    <div class="message" v-if="comment.messages">
      <template
        v-for="item in comment.messages"
        :key="item.nagId + item.approvalCount + item.messageId"
      >
        <comment-item
          type="message"
          :remarkId="comment.remarkId"
          :item="item"
          @reply="reply"
          @like="likeFn"
        />
      </template>
      <div class="more" v-show="comment.commentCount > 3" @click.stop="showAllCommentModal">查看其他{{ comment.commentCount - 3 }}条点评 <i></i></div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import CommentItem from './comment-item.vue'
export default defineComponent({
  components: {
    CommentItem
  },
  props: {
    comment: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  setup(props, cxt) {
    const reply = (options) => {
      cxt.emit('reply', options)
    }

    const likeFn = item => {
      cxt.emit('like', item)
    }

    const showAllCommentModal = () => {
      cxt.emit('showAll')
    }

    return {
      reply,
      likeFn,
      showAllCommentModal
    }
  }
})
</script>

<style lang="scss" scoped>
.question-comment {
  padding: 32px 30px 0;
  border-bottom: 2px solid #F5F5F7;
  &:last-child {
    border-bottom: none;
  }
  .message {
    padding-left: 56px;
    margin-top: 32px;
  }
  .more {
    display: flex;
    align-items: center;
    color: #6183F2;
    font-size: 28px;
    padding-left: 0.56rem;
    margin-bottom: 32px;
    i {
      display: inline-block;
      width: 20px;
      height: 20px;
      background-image: url('../img/question-more-icon.png');
      background-size: cover;
    }
  }
}
</style>
